/**
 * Helpers for cookie-based session (JWT in httpOnly cookie, not in JS).
 */

export const COOKIE_SESSION_SENTINEL = 'cookie-session'

export function hasClientSession() {
  try {
    if (localStorage.getItem('token')) return true
    const user = localStorage.getItem('user')
    if (!user) return false
    const parsed = JSON.parse(user)
    return Boolean(parsed?.uid)
  } catch {
    return false
  }
}

/**
 * Soft-clear leftover session markers + httpOnly cookie without hard reload.
 * Used on SignIn so idle/zombie sessions do not block MFA email OTP.
 * Preserves language and onboarding keys (unlike startLogout's full clear).
 */
export function softClearStaleSession() {
  try {
    const apiUrl = process.env.REACT_APP_API_URL
    if (apiUrl) {
      fetch(apiUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: 'mutation { logout }',
        }),
      }).catch(() => {})
    }
  } catch (_) {
    /* ignore */
  }

  try {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('logOut')
  } catch (_) {
    /* ignore */
  }
}
